import * as Orders from '../services/Orders'

export const RECEIVE_ORDERS = 'RECEIVE_ORDERS'
export const RECEIVE_ORDER = 'RECEIVE_ORDER'
export const RECEIVE_ORDER_LICENSES = 'RECEIVE_ORDER_LICENSES'

function receiveOrders(state, query, orders) {
  return {
    type: RECEIVE_ORDERS,
    query,
    orders
  }
}

function receiveOrder(order) {
  return {
    type: RECEIVE_ORDER,
    order
  }
}

function receiveLicenses(licenses, navID) {
  licenses.navID = navID
  return {
    type: RECEIVE_ORDER_LICENSES,
    licenses,
    navID
  }
}

function receiveLicense(licenses, navID) {
  licenses = []
  licenses.navID = navID
  return {
    type: RECEIVE_ORDER_LICENSES,
    licenses,
    navID
  }
}

export const searchOrders = (query) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  Orders.search(query, subsidiaryId).then( (data) => dispatch(receiveOrders(state, query, data) ) )  
}

export const fetchOrder = (id) => (dispatch, getState) => {
  Orders.fetch(id).then( (data) => dispatch(receiveOrder(data)))
}

export const fetchLicensesByItemId = (navID) => (dispatch, getState) => {
  Orders.fetchLicensesByItemId(navID).then( (data) => dispatch(receiveLicenses(data, navID)))
}

export const blockLicensesByNavisionId = (id, blocked) => (dispatch, getState) => {
  Orders.blockLicensesByNavisionId(id, blocked).then( (data) => dispatch(receiveLicense(data, id)))
}